import {getOriginalVersionedSettings} from '../EditPipelinePage/EditPipelinePage.selectors'
import {isYamlStoredInRepo} from '../EditPipelinePage/EditPipelinePage.utils'

import {usePipelineScope} from './pipeline'

import {useAppSelector} from 'src/hooks/react-redux'

function useIsYamlStoredInRepo() {
  const {pipelineId, branch} = usePipelineScope()
  const versionedSettings = useAppSelector(state =>
    getOriginalVersionedSettings(pipelineId, branch)(state),
  )
  return isYamlStoredInRepo(versionedSettings)
}

export default useIsYamlStoredInRepo
